import { DataRoomActivityDetail, DataRoomActivityWindow } from 'shared';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { selectedCompanyStorage } from '../../../../storage/company/selected-company.util';
import { keepWithinScope } from './keep-within-scope.util';

/** One room's Activity detail — 20.1.2 §5 to §11, with its own window (§6). */
export const useActivityRoomDetail = ({
  dataRoomId,
  window,
}: {
  dataRoomId: string;
  window: DataRoomActivityWindow;
}) => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { data, isError, isPending, isPlaceholderData, refetch } =
    useAppQuery<DataRoomActivityDetail>({
      queryFn: () =>
        ApiService.get<DataRoomActivityDetail>(
          { endpoint: BackendRoute.DATA_ROOM_ACTIVITY, routePath: ['rooms', dataRoomId] },
          { queryParams: { window } },
        ),
      placeholderData: keepWithinScope([
        QueryKey.GET_DATA_ROOM_ACTIVITY_DETAIL,
        companyId,
        dataRoomId,
      ]),
      queryKey: [QueryKey.GET_DATA_ROOM_ACTIVITY_DETAIL, companyId, dataRoomId, window],
    });

  return { detail: data, isError, isPending, isReloading: isPlaceholderData, retry: refetch };
};
